module.exports = __webpack_public_path__ + "img/vc.c73a7732.svg";